import axios from 'axios'
// import CONFIG from '@/config/index.js'
export const getwxConfig = params => axios.get(`/interface/api/site/Getjssdk?url=${params.url}&middle_type=${params.middle_type}`)

export const getName = params => axios.get(`/interface/api/qrcodeparameter/getname?id=${params.id}`)



// WEBPACK FOOTER //
// ./src/api/request.js